import { useStore, useConfirm, useToast, types } from '@balm-ui';
import { useDialog } from '@balm-ui-pro';
import { isDev } from '@yiban-shared/config';

const $confirm = useConfirm();
const $toast = useToast();
const $dialog = useDialog();

function getConfirmMessage(action, data) {
  const { messagePlaceholder, text, message } = action;

  let currentMessage = types.isFunction(message) ? message(data) : message;
  const currentText = types.isFunction(text) ? text(data) : text;

  if (/\%text/.test(currentMessage)) {
    currentMessage = currentMessage.replace('%text', currentText);
  }

  if (/\%s/.test(currentMessage)) {
    currentMessage = currentMessage.replace(
      '%s',
      types.isFunction(messagePlaceholder)
        ? messagePlaceholder(data)
        : data[messagePlaceholder]
    );
  }

  return currentMessage;
}

export default ({ getFormDataWithDefaultParams, afterHandler }) =>
  async function rowActionHandler(action, data, listViewData) {
    // 列表页行数据通用动作 用于指向相对应的 API 定义
    const actionType = types.isFunction(action.type)
      ? action.type(data)
      : action.type;

    if (!(actionType === 'router-link' || action.href)) {
      const $store = useStore();
      const { model, modelOptions, keyName, refreshData } = listViewData;

      // 弹窗操作
      if (actionType === 'dialog') {
        const { config } = action;
        const { attrOrProp, ...customDialogConfig } = config;

        $dialog({
          ...customDialogConfig,
          modelValueDefaults: data, // Formatting model value in dialog
          attrOrProp: Object.assign(
            {
              modelValueDefaults: data,
              actionConfig: [
                {
                  type: 'close',
                  text: '关闭',
                  attrOrProp: {
                    outlined: true
                  }
                },
                {
                  type: 'submit',
                  text: '保存',
                  attrOrProp: {
                    raised: true
                  }
                }
              ]
            },
            config.attrOrProp || {}
          ),
          refresh: refreshData
        });
      } else {
        // 普通操作
        const actionText = types.isFunction(action.text)
          ? action.text(data)
          : action.text || '操作';
        const resultMessage = types.isFunction(action.resultMessage)
          ? action.resultMessage(data)
          : `已${actionText}`;

        const message = getConfirmMessage(action, data);
        const canAction =
          action.noConfirm ||
          (message &&
            (await $confirm({
              message,
              raw: action.raw || false
            })));
        if (canAction) {
          let formData = {};

          if (Array.isArray(keyName)) {
            keyName.forEach((key) => {
              formData[key] = data[key];
            });
          } else {
            formData[action.keyField || keyName] =
              action.keyField === 'ids' || action.useMulti
                ? [data[keyName]]
                : data[keyName];
          }

          formData = getFormDataWithDefaultParams
            ? await getFormDataWithDefaultParams('row-action', formData, {
                actionType,
                action,
                data,
                ...listViewData
              })
            : formData;

          isDev && console.info('handleRowAction', model, formData);

          const result = /^del/.test(actionType)
            ? await $store.$deleteModel(model, formData, {
                apiAction: actionType === 'delete' ? '' : actionType
              })
            : await $store.$updateModel(model, formData, {
                apiAction: actionType === 'update' ? '' : actionType
              });

          $toast(resultMessage);
          refreshData();

          afterHandler &&
            afterHandler(formData, {
              actionType,
              action,
              data,
              ...listViewData,
              responseData: result
            });
        }
      }
    }
  };
